import * as React from "react";
import {LoadingViewState, RouterView} from "../RouterView";
import {RouteComponentProps, withRouter} from "react-router";
import {WalletService} from "../../services/WalletService";
import {getContainer} from "../../ioc/IOCSetup";
import {Credit, ListAccountsRequest, Settings} from "../../http/protocol";
import { Form, FormListener } from "../form/Form";
import {FormGroup} from "../form/FormGroup";
import { FormInput } from "../form/FormInput";
import { SelectInput } from "../form/SelectInput";
import { CreditService } from "../../services/CreditService";
import { Validators } from "../form/Validators";
import { ProviderService } from "../../services/ProviderService";
import { SettingsService } from "../../services/SettingsService";
import { Submit } from "../form/Submit";
import { FormTextArea } from "../form/FormTextArea";

interface State extends LoadingViewState{
    credit? : Credit;
    validationMap? : any;
    currencies? : string[];
    accounts? : string[];
}

export class CreditCreate extends RouterView<RouteComponentProps,State>implements FormListener<Credit>{

    creditService : CreditService;
    walletService : WalletService;
    providerService : ProviderService;
    settingsService : SettingsService;
    constructor(props : RouteComponentProps){
        super(props);
        this.creditService = getContainer().getCreditService();
        this.walletService = getContainer().getWalletService();
        this.providerService = getContainer().getProviderService();
        this.settingsService = getContainer().getSettingsService();
        this.state = { credit:{}, validationMap : {} , currencies : [], accounts:[]};
        this.handleChangeUser = this.handleChangeUser.bind(this);
    }

    getTitle() {
        return "Create Credit";
    }

    loadContent() {
        let id = (this.props.match.params as any).id;
        console.log(id);
        let array: string[] = [];
        return this.settingsService.getSettings().then( (s : Settings) => {
            s.currencies!.forEach((currency)=>{
                array.push(currency.code!);
            })
            this.setState({currencies:array});
        }) 
    }

    formDidUpdate(formModel: Credit, validationMap?: any) {
        this.setState({credit : formModel, validationMap : validationMap})
    }

    onSubmit()  {
        if(!this.state.credit) return;

        let credit : Credit = this.state.credit;
        credit.originalAmount = Number(credit.originalAmount);
        credit.owedAmount = Number(credit.originalAmount);
        credit.userId = Number(credit.userId);
        credit.accountId = Number(String(credit.accountId).split("-")[0].split(" ")[1]);

        this.creditService.addCredit(credit).then((response:Credit)=>{
            this.setState({credit:response});
            this.props.history.push("/credit/"+response.id);
        });
        
    }

    handleChangeUser(event:any) {
        let userId:number = event.target.value;
        let request: ListAccountsRequest = {};
        let array: string[] = [];
        if(userId!==undefined && String(userId)!==""){
            request.userId = userId;
            this.walletService.getAccountList(request).then((response:any)=>{
                response.items!.forEach((response:any)=>{
                    array.push("Acct "+response.id+" - Cur "+response.currencyCode+" - Type "+response.type+"");
                })
                this.setState({accounts:array});
            })
        } 
    }

    renderContent() {
        if (!this.state.credit) {
            return <div></div>;
        }
        return (
            <div>
                <div className="wrapper wrapper-content animated fadeInRight">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="card-box">
                                <Form className="form form-horizontal" validationMap={this.state.validationMap} modelObject={this.state.credit} formListener={this}>
                                    <FormGroup className="form-group">
                                        <label className="col-sm-2 control-label">External ID</label>
                                        <div className="col-sm-10">
                                            <FormInput  model="externalId" validators={[Validators.required()]} type="text" className="form-control" />
                                            <span className={"help"}>External ID for credit. Can not be repeated. i.e. Un grade message request Id</span>
                                        </div>
                                    </FormGroup>
                                    <div className="hr-line-dashed"></div>
                                    <FormGroup className="form-group">
                                        <label className="col-sm-2 control-label">Reference</label>
                                        <div className="col-sm-10">
                                            <FormInput  model="reference" validators={[]} type="text"  className="form-control" />
                                            <span className={"help"}>Short mention of entity related to credit. i.e. the bet id. If created manually this will be shown to the player.</span>
                                        </div>
                                    </FormGroup>
                                    <FormGroup className="form-group">
                                        <label className="col-sm-2 control-label">User ID</label>
                                        <div className="col-sm-10">
                                            <FormInput  model="userId" validators={[Validators.required()]} type="text" onChangeCapture={this.handleChangeUser} className="form-control" />
                                            <span className={"help"}>User ID  for create credit</span>
                                        </div>
                                    </FormGroup>
                                    <div className="hr-line-dashed"></div>
                                    <FormGroup className="form-group">
                                        <label className="col-sm-2 control-label">Account ID</label>
                                        <div className="col-sm-10">
                                            <SelectInput name="accountId" optional={true} className="form-control" values={this.state.accounts} model="accountId"  validators={[Validators.required()]} />
                                            <span className={"help"}>Account ID  for create credit. This determines the currency</span>
                                        </div>
                                    </FormGroup>
                                    <div className="hr-line-dashed"></div>
                                    <FormGroup className="form-group">
                                        <label className="col-sm-2 control-label">Provider</label>
                                        <div className="col-sm-10">
                                            <SelectInput name="provider" optional={true} className="form-control" model="provider"  values={this.providerService.listProviders()} validators={[Validators.required()]} />
                                            <span className={"help"}>Choose a provider from the active set (i.e. TAG, GBL, etc)</span>
                                        </div>
                                    </FormGroup>
                                    <div className="hr-line-dashed"></div>
                                    <FormGroup className="form-group">
                                        <label className="col-sm-2 control-label">Original Amount</label>
                                        <div className="col-sm-10">
                                            <FormInput  model="originalAmount" validators={[Validators.required()]} type="number"  className="form-control" />
                                            <span className={"help"}>Use a positive amount</span>
                                        </div>
                                    </FormGroup>
                                    <div className="hr-line-dashed"></div>
                                    <FormGroup className="form-group">
                                        <label className="col-sm-2 control-label">Request</label>
                                        <div className="col-sm-10">
                                            <FormTextArea  model="request" validators={[]} type="text"  className="form-control" />
                                            <span className={"help"}>Use to store request that triggered credit. Usually a json string.</span>
                                        </div>
                                    </FormGroup>

                                    <div className="hr-line-dashed"></div>
                                    <div className="form-group">
                                        <div className="col-sm-12">
                                            <Submit className="btn  btn-primary">Save</Submit>
                                        </div>
                                    </div>
                           

                                </Form>
                            </div>
                        </div>
                    </div>
                </div>      
            </div>
        );
    }
}
export default withRouter(CreditCreate);